import React, { useEffect } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import "./Cookie.css";

const Cookie = () => {
    const loadGoogleTag = () => {
        if (window._gLoaded) return; // Mehrfachladen verhindern
        window._gLoaded = true;

        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            '//www.googletagmanager.com/gtag/js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','G-NML7PB70RF');

        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}

        gtag('consent', 'default', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
        });

        gtag('js', new Date());
        gtag('config', 'G-NML7PB70RF');

        gtag('consent', 'update', {
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'ad_storage': 'granted',
            'analytics_storage': 'granted'
        });
    };

    // Prüfen, ob Cookie bereits gesetzt wurde
    useEffect(() => {
        const consent = getCookieConsentValue();
        if (consent === "true") {
            loadGoogleTag();
        }
    }, []);

    return (
        <CookieConsent
            location="bottom"
            buttonText="Akzeptieren"
            declineButtonText="Ablehnen"
            enableDeclineButton
            flipButtons
            containerClasses="cookie-container"
            buttonClasses="cookie-accept"
            declineButtonClasses="cookie-decline"
            contentClasses="cookie-content"
            onAccept={loadGoogleTag}
        >
            Wir verwenden Cookies und Analyse-Tools, um unsere Website und unseren Service zu optimieren.{" "}
            <a href="https://www.ambion.de/datenschutzerklaerung/" className="cookie-link">
                Datenschutzerklärung
            </a>
        </CookieConsent>
    );
};

export default Cookie;